import { render, staticRenderFns } from "./ImpersonateBar.vue?vue&type=template&id=635c3e0e&scoped=true&"
import script from "./ImpersonateBar.vue?vue&type=script&lang=ts&"
export * from "./ImpersonateBar.vue?vue&type=script&lang=ts&"
import style0 from "./ImpersonateBar.vue?vue&type=style&index=0&id=635c3e0e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635c3e0e",
  null
  
)

export default component.exports